import { create } from 'zustand';

interface IFreeHistoryStore {
  viewedContent: { slug: string, isValid: boolean }[];
  isBlocked: boolean;
  setViewedContent: (newViewedContent: { slug: string, isValid: boolean }[]) => void;
  setIsBlocked: (newIsBlocked: boolean) => void;
}

const useFreeHistoryStore = create<IFreeHistoryStore>((set) => ({
  viewedContent: [],
  isBlocked: false,
  setViewedContent: (newViewedContent) => set({ viewedContent: newViewedContent }),
  setIsBlocked: (newIsBlocked) => set({ isBlocked: newIsBlocked }),
}));

export { useFreeHistoryStore };
